import React, { useEffect, useState } from 'react'
import Text from '../../components/text/Text'
import back from '../../assets/icons/icons-arrow-back.svg'
import './BillingDocument.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { useLoadingContext } from '../../context/spinnerContext'
import {
    getBillingDetailInfo,
    getPaymentDataInfo,
} from '../../services/billing'
import moment from 'moment'
import routes from '../../router/routes'
import { formatRut } from '../../formatters'
import { formatCurrency } from '../../utils'

interface IInvoiceData {
    rut: string
    razonSocial: string
    giro: string
    direcion: string
    comisionAvance: string
}
interface IDetalleDocumento {
    descripcionDetalle: string
    monto: string
}
interface IDetalleMovimientos {
    codigoMC: string
    fecha: string
    monto: string
}
interface IDocumentData {
    fechaEmisionFactura: string
    fechaRecepcionFactura: string
    fechaVencimientoFactura: string
    iva: string
    montoNeto: string
    total: string
    nFactura: string
    detalleDocumento: IDetalleDocumento[]
    detalleMovimientos: IDetalleMovimientos[]
}

const BillingDocument = () => {
    const navigate = useNavigate()
    const loadingContext = useLoadingContext()
    const location = useLocation()
    const movementDetails = location.state?.movementDetails
    console.log(
        'movementDetails movementDetails movementDetails',
        movementDetails
    )
    const conciliation = movementDetails.conciliacion1
    const docNumber = movementDetails.documento
    const docType = movementDetails.tipoDocumento
    const movementType = movementDetails.tipoMovimiento

    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const sEstablecimiento = user?.sEstablecimiento

    const [hasInvoice, setHasInvoice] = useState(false)
    const [invoiceData, setInvoiceData] = useState<IInvoiceData | null>(null)
    const [documentData, setDocumentData] = useState<IDocumentData | null>(null)

    const getHistoryInfo = async () => {
        try {
            loadingContext?.onOpen()
            const resp = await getBillingDetailInfo()
            const info = resp.body.data
            const hasInvoiceTmp = info.poseeFactura
            setHasInvoice(hasInvoiceTmp)
            setInvoiceData(info)
        } catch (err) {
            console.error('Error al cargar el historial de facturación:', err)
        } finally {
            loadingContext?.onClose()
        }
    }

    const getPaymentInfo = async () => {
        try {
            loadingContext?.onOpen()
            const resp = await getPaymentDataInfo(
                sEstablecimiento,
                conciliation,
                docNumber,
                docType,
                movementType
            )
            const info = resp.body.data

            const hasInvoiceTmp = info.poseeFactura
            setHasInvoice(hasInvoiceTmp)
            setDocumentData(info)
        } catch (err) {
            console.error('Error al cargar el detalle del documento:', err)
        } finally {
            loadingContext?.onClose()
        }
    }
    useEffect(() => {
        getHistoryInfo()
    }, [])
    useEffect(() => {
        getPaymentInfo()
    }, [])

    const getMomentOrString = (rawDate: string | undefined) => {
        if (rawDate?.length === 10) {
            return rawDate
        }
        if (moment(rawDate).isValid()) {
            return moment(rawDate).format('DD-MM-YYYY')
        }
        return rawDate
    }
    return (
        <div>
            <div className="billing-flex-direction">
                <img
                    src={back}
                    onClick={() =>
                        navigate(`/${routes.billing}/${routes.billingMain}`)
                    }
                />
                <Text
                    label={'Detalle Documento'}
                    fontSize={20}
                    fontWeight={600}
                    color={'#656565'}
                    marginLeft={15}
                />
            </div>

            <div className="billing-document-flex-direction">
                <div>
                    <div className="billing-document-text-container">
                        <div>
                            <Text
                                label={`Razón social`}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginBottom={10}
                            />
                            <Text
                                label={invoiceData?.razonSocial}
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                            />
                        </div>
                        <div>
                            <Text
                                label={'Fecha emisión'}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginBottom={10}
                            />
                            <Text
                                label={getMomentOrString(
                                    documentData?.fechaEmisionFactura
                                )}
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                                textAlign={'end'}
                            />
                        </div>
                    </div>

                    <div className="billing-document-text-container">
                        <div>
                            <Text
                                label={`Rut`}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginBottom={10}
                            />
                            <Text
                                label={
                                    invoiceData?.rut
                                        ? formatRut(invoiceData.rut)
                                        : 'Rut no disponible'
                                }
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                            />
                        </div>
                        <div>
                            <Text
                                label={'Fecha vencimiento'}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginBottom={10}
                            />
                            <Text
                                label={getMomentOrString(
                                    documentData?.fechaVencimientoFactura
                                )}
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                                textAlign={'end'}
                            />
                        </div>
                    </div>

                    <div className="billing-document-text-container">
                        <div>
                            <Text
                                label={`Dirección`}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginBottom={10}
                            />
                            <Text
                                label={invoiceData?.direcion}
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                            />
                        </div>
                        <div>
                            <Text
                                label={'Fecha recepción'}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginBottom={10}
                            />
                            <Text
                                label={getMomentOrString(
                                    documentData?.fechaRecepcionFactura
                                )}
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                                textAlign={'end'}
                            />
                        </div>
                    </div>

                    <div className="billing-document-text-container">
                        <div>
                            <Text
                                label={`Giro`}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginBottom={10}
                            />
                            <Text
                                label={invoiceData?.giro}
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                            />
                        </div>
                        <div>
                            <Text
                                label={'N* Factura'}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginBottom={10}
                            />
                            <Text
                                label={
                                    documentData?.nFactura
                                        ? documentData?.nFactura
                                        : '-'
                                }
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                                textAlign={'end'}
                            />
                        </div>
                    </div>
                    <div className="billing-document-text-container">
                        <div>
                            <Text
                                label={`Pronto pago`}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginBottom={10}
                            />
                            <Text
                                label={'Si'}
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                            />
                        </div>
                    </div>
                </div>
                <div>
                    <div className="billing-document-text-container">
                        <div>
                            <Text
                                label={`Detalle`}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginBottom={10}
                            />
                            <Text
                                label={
                                    documentData?.detalleDocumento[0]
                                        .descripcionDetalle
                                }
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                                style={{
                                    width: '60%',
                                }}
                            />
                        </div>
                        <div>
                            <Text
                                label={'Total'}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginBottom={10}
                                textAlign={'end'}
                            />
                            <Text
                                label={documentData?.detalleDocumento[0].monto}
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                                style={{
                                    width: 90,
                                }}
                                textAlign={'end'}
                            />
                        </div>
                    </div>
                    <div className="billing-document-text-container">
                        <div className="b-flex-normal">
                            <Text
                                label={`Comisión avance factura:`}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginBottom={10}
                            />
                            <Text
                                label={formatCurrency(
                                    invoiceData?.comisionAvance
                                )}
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                            />
                        </div>
                    </div>
                    <div className="billing-document-text-container">
                        <div className="b-flex-normal">
                            <Text
                                label={`Monto Neto:`}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginBottom={10}
                            />
                            <Text
                                label={formatCurrency(documentData?.montoNeto)}
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                            />
                        </div>
                    </div>
                    <div className="billing-document-text-container">
                        <div className="b-flex-normal">
                            <Text
                                label={`Iva:`}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginBottom={10}
                            />
                            <Text
                                label={formatCurrency(documentData?.iva)}
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                            />
                        </div>
                    </div>
                    <div className="billing-document-text-container">
                        <div className="b-flex-normal">
                            <Text
                                label={`Total:`}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginBottom={10}
                            />
                            <Text
                                label={formatCurrency(documentData?.total)}
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="billing-downloado-pdf-button">
                <Text
                    label={'Descargar Pdf'}
                    fontSize={14}
                    fontWeight={600}
                    color={'white'}
                />
            </div>
            <div className="billing-grid">
                <div className="billing-grid-header">
                    <Text
                        label={'Fecha'}
                        fontSize={12}
                        fontWeight={600}
                        color={'#000000'}
                    />
                </div>
                <div className="billing-grid-header">
                    <Text
                        label={'ID Transacción'}
                        fontSize={12}
                        fontWeight={600}
                        color={'#000000'}
                    />
                </div>
                <div className="billing-grid-header">
                    <Text
                        label={'Monto'}
                        fontSize={12}
                        fontWeight={600}
                        color={'#000000'}
                    />
                </div>

                {documentData?.detalleMovimientos?.map((movimiento, index) => (
                    <React.Fragment key={index}>
                        <div className="billing-grid-item">
                            {moment(movimiento.fecha).format('DD-MM-YYYY')}
                        </div>
                        <div className="billing-grid-item">
                            {movimiento.codigoMC}
                        </div>
                        <div className="billing-grid-item">
                            {formatCurrency(movimiento.monto)}
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </div>
    )
}

export default BillingDocument
